import Vue from 'vue'
import VueSidebarMenu from 'vue-sidebar-menu'

Vue.component('vue-sidebar-menu', VueSidebarMenu)

Vue.use(VueSidebarMenu)
